"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WalletRepository = exports.PaginatedWalletListResponseSchema = void 0;
const zod_1 = require("zod");
const httpRepository_1 = __importDefault(require("./httpRepository"));
const WalletDetailsRequesterSchema = zod_1.z.object({
    email: zod_1.z.union([zod_1.z.null(), zod_1.z.string()]).optional(),
    firstName: zod_1.z.union([zod_1.z.null(), zod_1.z.string()]).optional(),
    lastName: zod_1.z.union([zod_1.z.null(), zod_1.z.string()]).optional(),
});
const WalletDetailsRequestSchema = zod_1.z.object({
    amount: zod_1.z.union([zod_1.z.number(), zod_1.z.null()]).optional(),
    approver: zod_1.z.union([zod_1.z.null(), zod_1.z.string()]).optional(),
    businessId: zod_1.z.union([zod_1.z.null(), zod_1.z.string()]).optional(),
    cardType: zod_1.z.union([zod_1.z.null(), zod_1.z.string()]).optional(),
    currency: zod_1.z.union([zod_1.z.null(), zod_1.z.string()]).optional(),
    isArchived: zod_1.z.union([zod_1.z.boolean(), zod_1.z.null()]).optional(),
    lastEdit: zod_1.z.union([zod_1.z.coerce.date(), zod_1.z.null()]).optional(),
    profileId: zod_1.z.union([zod_1.z.null(), zod_1.z.string()]).optional(),
    authPaddingPercentage: zod_1.z.union([zod_1.z.number(), zod_1.z.null()]).optional(),
    requestId: zod_1.z.union([zod_1.z.null(), zod_1.z.string()]).optional(),
    state: zod_1.z.union([zod_1.z.null(), zod_1.z.string()]).optional(),
    teamId: zod_1.z.union([zod_1.z.null(), zod_1.z.string()]).optional(),
    title: zod_1.z.union([zod_1.z.null(), zod_1.z.string()]).optional(),
    virtualCardId: zod_1.z.union([zod_1.z.null(), zod_1.z.string()]).optional(),
    requester: zod_1.z.union([WalletDetailsRequesterSchema, zod_1.z.null()]).optional(),
});
const ApproverClassSchema = zod_1.z.object({});
const WalletDetailsFieldsSchema = zod_1.z.object({
    amount: zod_1.z.union([zod_1.z.null(), zod_1.z.string()]).optional(),
    description: zod_1.z.union([zod_1.z.null(), zod_1.z.string()]).optional(),
    endDate: zod_1.z.union([zod_1.z.null(), zod_1.z.string()]).optional(),
    numberOfPayments: zod_1.z.union([zod_1.z.null(), zod_1.z.string()]).optional(),
    ends: zod_1.z.union([zod_1.z.null(), zod_1.z.string()]).optional(),
    frequency: zod_1.z.union([zod_1.z.null(), zod_1.z.string()]).optional(),
    comments: zod_1.z.union([zod_1.z.null(), zod_1.z.string()]).optional(),
});
const CostcentercodeSchema = zod_1.z.object({
    listId: zod_1.z.union([zod_1.z.null(), zod_1.z.string()]).optional(),
    listLabel: zod_1.z.union([zod_1.z.null(), zod_1.z.string()]).optional(),
});
const CodingSchema = zod_1.z.object({
    costcentercode: zod_1.z.union([CostcentercodeSchema, zod_1.z.null()]).optional(),
});
const ContextRequestSchema = zod_1.z.object({
    amount: zod_1.z.union([zod_1.z.null(), zod_1.z.string()]).optional(),
    approver: zod_1.z.union([ApproverClassSchema, zod_1.z.null()]).optional(),
    attachments: zod_1.z.union([zod_1.z.array(zod_1.z.any()), zod_1.z.null()]).optional(),
    authPaddingPercentage: zod_1.z.union([zod_1.z.number(), zod_1.z.null()]).optional(),
    businessId: zod_1.z.union([zod_1.z.null(), zod_1.z.string()]).optional(),
    cardType: zod_1.z.union([zod_1.z.null(), zod_1.z.string()]).optional(),
    coding: zod_1.z.union([CodingSchema, zod_1.z.null()]).optional(),
    companyId: zod_1.z.union([zod_1.z.null(), zod_1.z.string()]).optional(),
    currency: zod_1.z.union([zod_1.z.null(), zod_1.z.string()]).optional(),
    fields: zod_1.z.union([WalletDetailsFieldsSchema, zod_1.z.null()]).optional(),
    isArchived: zod_1.z.union([zod_1.z.boolean(), zod_1.z.null()]).optional(),
    lastEdit: zod_1.z.union([zod_1.z.coerce.date(), zod_1.z.null()]).optional(),
    profileId: zod_1.z.union([zod_1.z.null(), zod_1.z.string()]).optional(),
    requester: zod_1.z.union([WalletDetailsRequesterSchema, zod_1.z.null()]).optional(),
    requestId: zod_1.z.union([zod_1.z.null(), zod_1.z.string()]).optional(),
    state: zod_1.z.union([zod_1.z.null(), zod_1.z.string()]).optional(),
    teamId: zod_1.z.union([zod_1.z.null(), zod_1.z.string()]).optional(),
    title: zod_1.z.union([zod_1.z.null(), zod_1.z.string()]).optional(),
    virtualCardId: zod_1.z.union([zod_1.z.null(), zod_1.z.string()]).optional(),
});
const ContextSchema = zod_1.z.object({
    request: zod_1.z.union([ContextRequestSchema, zod_1.z.null()]).optional(),
});
const _WalletDetailsSchema = zod_1.z.object({
    assignedOn: zod_1.z.union([zod_1.z.number(), zod_1.z.null()]).optional(),
    assignees: zod_1.z.union([zod_1.z.array(zod_1.z.string()), zod_1.z.null()]).optional(),
    assigner: zod_1.z.union([zod_1.z.null(), zod_1.z.string()]).optional(),
    context: zod_1.z.union([ContextSchema, zod_1.z.null()]).optional(),
    id: zod_1.z.union([zod_1.z.null(), zod_1.z.string()]).optional(),
    state: zod_1.z.union([zod_1.z.null(), zod_1.z.string()]).optional(),
    subjectId: zod_1.z.string(),
    request: zod_1.z.union([WalletDetailsRequestSchema, zod_1.z.null()]).optional(),
});
const RequestSchema = zod_1.z.object({
    amount: zod_1.z.union([zod_1.z.null(), zod_1.z.string()]).optional(),
    authPaddingPercentage: zod_1.z.union([zod_1.z.number(), zod_1.z.null()]).optional(),
    businessId: zod_1.z.union([zod_1.z.null(), zod_1.z.string()]).optional(),
    cardType: zod_1.z.union([zod_1.z.null(), zod_1.z.string()]).optional(),
    coding: zod_1.z.union([CodingSchema, zod_1.z.null()]).optional(),
    companyId: zod_1.z.union([zod_1.z.null(), zod_1.z.string()]).optional(),
    currency: zod_1.z.union([zod_1.z.null(), zod_1.z.string()]).optional(),
    isArchived: zod_1.z.union([zod_1.z.boolean(), zod_1.z.null()]).optional(),
    lastEdit: zod_1.z.union([zod_1.z.coerce.date(), zod_1.z.null()]).optional(),
    profileId: zod_1.z.union([zod_1.z.null(), zod_1.z.string()]).optional(),
    requestId: zod_1.z.union([zod_1.z.null(), zod_1.z.string()]).optional(),
    state: zod_1.z.union([zod_1.z.null(), zod_1.z.string()]).optional(),
    teamId: zod_1.z.union([zod_1.z.null(), zod_1.z.string()]).optional(),
    title: zod_1.z.union([zod_1.z.null(), zod_1.z.string()]).optional(),
    virtualCardId: zod_1.z.union([zod_1.z.null(), zod_1.z.string()]).optional(),
    fields: zod_1.z.union([WalletDetailsFieldsSchema, zod_1.z.null()]).optional(),
});
const CardSchema = zod_1.z.object({
    cardType: zod_1.z.union([zod_1.z.null(), zod_1.z.string()]).optional(),
    cvv: zod_1.z.union([zod_1.z.null(), zod_1.z.string()]).optional(),
    id: zod_1.z.union([zod_1.z.null(), zod_1.z.string()]).optional(),
    value: zod_1.z.union([zod_1.z.number(), zod_1.z.null()]).optional(),
    balance: zod_1.z.union([zod_1.z.number(), zod_1.z.null()]).optional(),
    currency: zod_1.z.union([zod_1.z.null(), zod_1.z.string()]).optional(),
    expiryDate: zod_1.z.union([zod_1.z.null(), zod_1.z.string()]).optional(),
    expiry: zod_1.z.union([zod_1.z.null(), zod_1.z.string()]).optional(),
    validEndingOn: zod_1.z.union([zod_1.z.null(), zod_1.z.string()]).optional(),
    number: zod_1.z.union([zod_1.z.null(), zod_1.z.string()]).optional(),
    owner: zod_1.z.union([zod_1.z.null(), zod_1.z.string()]).optional(),
    sourceId: zod_1.z.union([zod_1.z.null(), zod_1.z.string()]).optional(),
    status: zod_1.z.union([zod_1.z.null(), zod_1.z.string()]).optional(),
    initialCardValue: zod_1.z.union([zod_1.z.number(), zod_1.z.null()]).optional(),
    lastDigits: zod_1.z.union([zod_1.z.null(), zod_1.z.string()]).optional(),
    createdAt: zod_1.z.string().optional(),
    provisioner: zod_1.z.string().optional(),
    teamId: zod_1.z.string().optional(),
    provider: zod_1.z.union([zod_1.z.literal('AMEX'), zod_1.z.literal('HSBC'), zod_1.z.null()]).optional(),
    billingAddress: zod_1.z
        .object({
        addressLine1: zod_1.z.string(),
        city: zod_1.z.string(),
        countryCode: zod_1.z.string(),
        region: zod_1.z.string(),
        zipCode: zod_1.z.string(),
    })
        .optional(),
});
const TaskSchema = zod_1.z.object({
    id: zod_1.z.union([zod_1.z.null(), zod_1.z.string()]).optional(),
    handler: zod_1.z.union([zod_1.z.null(), zod_1.z.string()]).optional(),
    groupId: zod_1.z.union([zod_1.z.null(), zod_1.z.string()]).optional(),
    state: zod_1.z.union([zod_1.z.null(), zod_1.z.string()]).optional(),
    createdOn: zod_1.z.union([zod_1.z.number(), zod_1.z.null()]).optional(),
    subjectId: zod_1.z.union([zod_1.z.null(), zod_1.z.string()]).optional(),
    context: zod_1.z.union([ContextSchema, zod_1.z.null()]).optional(),
    assigner: zod_1.z.union([zod_1.z.null(), zod_1.z.string()]).optional(),
    assignedOn: zod_1.z.union([zod_1.z.number(), zod_1.z.null()]).optional(),
    assignees: zod_1.z.union([zod_1.z.array(zod_1.z.string()), zod_1.z.null()]).optional(),
    request: zod_1.z.union([RequestSchema, zod_1.z.null()]).optional(),
    card: zod_1.z.union([CardSchema, zod_1.z.null()]).optional(),
});
exports.PaginatedWalletListResponseSchema = zod_1.z.object({
    count: zod_1.z.number(),
    tasks: zod_1.z.union([zod_1.z.array(TaskSchema), zod_1.z.null()]).optional(),
    hasNextPage: zod_1.z.boolean().optional(),
    // we need this, so we do not disable the next pager when we have null values in tasks
    initialPaginatedWalletDataCount: zod_1.z.number(),
});
exports.WalletRepository = {
    getUsersListForActiveTeam: async ({ teamId, userId }) => {
        const params = {
            teamId,
            owner: userId,
            limit: 50,
            page: 0,
        };
        const response = await httpRepository_1.default.tradeshiftGo().get('/rest/v2/wallet', {
            params,
            timeout: 5000,
        });
        return response.data;
    },
    getWalletDetails: async ({ taskId }) => {
        const response = await httpRepository_1.default.tradeshiftGo().get(`/rest/wallet/${taskId}`);
        return response.data;
    },
    getPaginatedWalletList: async ({ limit, page, teamId, owner, status, sortBy, sortOrder, }) => {
        const params = {
            limit: limit || 10,
            page: page || 0,
            ...(teamId ? { teamId } : {}),
            ...(owner ? { owner } : {}),
            status,
            sortBy,
            sortOrder,
        };
        const response = await httpRepository_1.default.tradeshiftGo().get('/rest/v2/wallet', {
            params,
            timeout: 5000,
        });
        return response.data;
    },
    cancelVirtualCard: async ({ subjectId, virtualCardId }) => {
        const response = await httpRepository_1.default.tradeshiftGo().post(`/rest/tasks/${subjectId}/cards/${virtualCardId}`);
        return response.data;
    },
    getVirtualCardTask: async (options) => {
        const response = await httpRepository_1.default.tradeshiftGo().get(`/rest/tasks/card/${options.virtualCardId}`);
        return response.data;
    },
};
